import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css";

export default function Gallery() {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");

  // 🔥 NEW STATES
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const API_BASE = "https://payyanur.cubixsystems.com/myapp/api";

  useEffect(() => {
    axios.get(`${API_BASE}/fetch_categories.php`)
      .then(res => setCategories(Array.isArray(res.data) ? res.data : []))
      .catch(() => setCategories([]));
  }, []);

  useEffect(() => {
    axios.get(`${API_BASE}/fetch_gallery.php?category_id=${activeCategory}`)
      .then(res => setImages(Array.isArray(res.data) ? res.data : []))
      .catch(() => setImages([]));
  }, [activeCategory]);

  // 🔹 OPEN IMAGE
  const openImage = (index) => {
    setCurrentIndex(index);
    setShowModal(true);
  };

  // 🔹 CLOSE IMAGE
  const closeModal = () => setShowModal(false);

  // 🔹 NEXT & PREV
  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  return (
    <div className="gallery-container">
      {/* CATEGORY BUTTONS */}
      <div className="category-tabs">
        <button
          className={activeCategory === "all" ? "active" : ""}
          onClick={() => setActiveCategory("all")}
        >
          Show All
        </button>

        {categories.map((cat) => (
          <button
            key={cat.id}
            className={activeCategory === cat.id ? "active" : ""}
            onClick={() => setActiveCategory(cat.id)}
          >
            {cat.category_name}
          </button>
        ))}
      </div>

      {/* IMAGE GRID */}
      <div className="gallery-grid">
        {images.length === 0 ? (
          <p>No images found</p>
        ) : (
          images.map((img, index) => (
            <div
              className="gallery-item"
              key={img.id}
              onClick={() => openImage(index)}
            >
              <img
                src={`https://payyanur.cubixsystems.com/myapp/uploads/gallery/${img.image_name}`}
                alt=""
              />
            </div>
          ))
        )}
      </div>

      {/* 🔥 MODAL */}
      {showModal && (
        <div className="lightbox">
          <span className="close" onClick={closeModal}>×</span>

          <span className="prev" onClick={prevImage}>❮</span>

          <img
            className="lightbox-img"
            src={`https://payyanur.cubixsystems.com/myapp/uploads/gallery/${images[currentIndex].image_name}`}
            alt=""
          />

          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </div>
  );
}
